import { useState } from 'react';
import { NILogoSimpleIcon } from '@native-instruments/webex-ni';

import Footer from '../Footer';
import Header from '../Header';
import HamburgerMenu from './HamburgerMenu';
import {
  BackgroundWrapper,
  FullHeightWrapper,
  SubHeader,
  SubHeaderMenuItems,
  SubHeaderMenuWrapper,
  SubHeaderTitle,
} from './Skeleton.styles';

const Skeleton = ({
  simpleHeader,
  children,
}: {
  simpleHeader?: boolean;
  children: React.ReactNode;
}) => (
  <FullHeightWrapper>
    <BackgroundWrapper>
      {simpleHeader === true ? (
        <div className="ni-tailwind-namespace">
          <div className="flex items-center justify-center">
            <div className="py-4">
              <NILogoSimpleIcon width={40} height={24} />
            </div>
          </div>
        </div>
      ) : (
        <Header />
      )}
      {children}
    </BackgroundWrapper>
    <Footer />
  </FullHeightWrapper>
);

const SubHeaderMenu = ({ children }: { children: React.ReactNode }) => {
  const [isMenuOpen, toggleMenu] = useState(false);
  return (
    <SubHeaderMenuWrapper>
      <HamburgerMenu isOpen={isMenuOpen} toggle={toggleMenu} />
      <SubHeaderMenuItems isVisible={isMenuOpen}>{children}</SubHeaderMenuItems>
    </SubHeaderMenuWrapper>
  );
};

export { Skeleton, SubHeader, SubHeaderMenu, SubHeaderTitle };
